import { Link } from '@inertiajs/react'
import { LucideIcon } from 'lucide-react'

interface ActionCardProps {
    href: string
    icon: LucideIcon
    title: string
    description: string
    buttonText: string
    colorScheme: 'blue' | 'green' | 'indigo'
}

const colorClasses = {
    blue: {
        border: 'hover:border-blue-200',
        iconBg: 'bg-blue-100 group-hover:bg-blue-200',
        iconColor: 'text-blue-600',
        titleHover: 'group-hover:text-blue-600',
        button: 'bg-blue-600 group-hover:bg-blue-700'
    },
    green: {
        border: 'hover:border-green-200',
        iconBg: 'bg-green-100 group-hover:bg-green-200',
        iconColor: 'text-green-600',
        titleHover: 'group-hover:text-green-600',
        button: 'bg-green-600 group-hover:bg-green-700'
    },
    indigo: {
        border: 'hover:border-indigo-200',
        iconBg: 'bg-indigo-100 group-hover:bg-indigo-200',
        iconColor: 'text-indigo-600',
        titleHover: 'group-hover:text-indigo-600',
        button: 'bg-indigo-600 group-hover:bg-indigo-700'
    }
}

export default function ActionCard({
    href,
    icon: Icon,
    title,
    description,
    buttonText,
    colorScheme
}: ActionCardProps) {
    const colors = colorClasses[colorScheme]

    return (
        <Link
            href={href}
            className={`group relative bg-white p-8 rounded-xl shadow-lg hover:shadow-xl transition-all duration-200 border-2 border-transparent ${colors.border}`}
        >
            <div className="text-center">
                <div
                    className={`mx-auto h-16 w-16 ${colors.iconBg} rounded-full flex items-center justify-center transition-colors`}
                >
                    <Icon className={`h-8 w-8 ${colors.iconColor}`} />
                </div>
                <h3 className={`mt-6 text-2xl font-bold text-gray-900 ${colors.titleHover} transition-colors`}>
                    {title}
                </h3>
                <p className="mt-3 text-gray-600">
                    {description}
                </p>
                <div className="mt-6">
                    <span
                        className={`inline-flex items-center px-4 py-2 ${colors.button} text-white text-sm font-medium rounded-lg transition-colors`}
                    >
                        {buttonText} →
                    </span>
                </div>
            </div>
        </Link>
    )
}